export enum InputStatus {
  ERROR = "error",
  SUCCESS = "success",
  IDLE = "idle"
}
